import { combineReducers } from '@reduxjs/toolkit'

import { REDUCER_INDEX } from '../constants'
import * as institutions from './institutions'
import * as tournaments from './tournaments'

export const actions = {
  ...institutions.actions,
  ...tournaments.actions,
}

export const epics = [...tournaments.epics, ...institutions.epics]

export const reducer = combineReducers({
  institutions: institutions.reducer,
  tournaments: tournaments.reducer,
})

interface State {
  institutions: ReturnType<typeof institutions.reducer>
  tournaments: ReturnType<typeof tournaments.reducer>
}

export const selectors = {
  institutions: ({ [REDUCER_INDEX]: state }: { [REDUCER_INDEX]: State }) => state.institutions,
  tournaments: ({ [REDUCER_INDEX]: state }: { [REDUCER_INDEX]: State }) => state.tournaments,
}

export const registerReducer = (state: Record<string, unknown>) => ({
  ...state,
  [REDUCER_INDEX]: reducer,
})
